export const TAGS = {
  NO_ANSWER: 'بدون_پاسخ',
  LOW_VIEW: 'بازدید_کم',
  REACT: 'ری‌اکت',
  DIRTY: 'محتوای_نامناسب',
  MUSIC: 'موسیقی',
  VIOLENCE: 'خشونت',
  COPYRIGHT: 'حق_تکثیر',
  GAME_NO_TALK: 'بازی_بدون_صحبت',
  MAGIC_AND_SPELLS: 'جادو_و_طلسم',
  NEEDS_CORRECTION: 'نیاز_به_اصلاح',
  INITIAL_REVIEW: 'بررسی_اولیه',
  WAITING_ACCESS: 'منتظر_دسترسی',
  HAS_MULTIPLE_CHANNELS: 'چند_کانال_داره',
  WAITING_ADSENSE: 'منتظر_وصل_به_ادسنس',
  WAITING_ACCEPTANCE: 'منتظر_تایید',
  USELESS_CONTENT: 'کم_ارزش',
  THIRD_PARTY_CONTRACT: 'قرارداد_با_شرکت_دیگر',
  VIP: 'VIP',
  DELAYED_RESPONSE: 'تاخیر_در_پاسخگویی',
  CONTRACT_TERMS: 'مفاد_قرارداد',
  NOT_OWNER: 'عدم_مالکیت_کانال',
  CUSTOM_ADSENSE: 'اتصال_به_ادسنس_های_اختصاصی',
  MISJUDGED_CONTENT: 'ارزیابی_اشتباهی_محتوا',
  FAIR_USE_NOT_RESPECTED: 'فریوز_رعایت_نشده',
  PENDING_DOCUMENTS: 'درحال_تکمیل_مدارک',
  LIVE: 'لایو_کار_میکنه',
  NON_IRANIAN: 'غیر_ایرانی',
};
